import type { Article } from "./types";

export const rsvpAndCutoffDate: Article = {
  slug: "rsvp-and-cutoff-date",
  published: true,
  publishedAt: "2026-10-06",
  updatedAt: "2026-10-06",
  title: {
    ro: "Confirmarea prezenței (RSVP) și data limită",
    en: "Attendance confirmation (RSVP) and the cutoff date",
  },
  summary: {
    ro: "Cum își confirmă invitații prezența pe pagina evenimentului, unde vezi răspunsurile și ce se întâmplă după data limită RSVP.",
    en: "How guests confirm attendance on the event page, where you see their answers and what happens after the RSVP cutoff date.",
  },
  body: {
    ro: [
      { t: "h2", text: "Cum răspund invitații" },
      { t: "p", text: "Invitații deschid pagina evenimentului din link-ul primit și folosesc secțiunea „Confirmă prezența”. Nu au nevoie de cont sau de aplicație, iar pagina se poate folosi și de pe telefon." },
      { t: "p", text: "În formular aleg „Da, venim cu drag” sau „Nu putem ajunge”, completează datele cerute și trimit răspunsul. După trimitere primesc o confirmare pe ecran." },
      { t: "p", text: "Dacă un invitat vrea să își schimbe răspunsul după ce l-a trimis, trebuie să contacteze gazdele evenimentului." },
      { t: "h2", text: "Unde vezi răspunsurile" },
      { t: "p", text: "Răspunsurile apar în tab-ul „Invitați” din editorul evenimentului." },
      { t: "h2", text: "Data limită RSVP" },
      { t: "p", text: "Tot în tab-ul „Invitați” poți seta „Data limită RSVP”. După această dată, formularul RSVP este ascuns de pe pagină. Dacă lista de cadouri este activă și vizibilă pentru eveniment, invitații ajung în continuare la cadouri de pe pagină." },
      { t: "p", text: "Poți schimba data sau o poți șterge oricând din același loc. Fără o dată limită, formularul rămâne disponibil." },
    ],
    en: [
      { t: "h2", text: "How guests answer" },
      { t: "p", text: "Guests open the event page from the link they received and use the “Confirm attendance” section. They do not need an account or an app, and the page also works on a phone." },
      { t: "p", text: "In the form they choose “Yes, we will be there” or “No, we can't make it”, fill in the requested details and send their answer. After sending it, they see a confirmation on screen." },
      { t: "p", text: "If a guest wants to change their answer after sending it, they need to contact the event hosts." },
      { t: "h2", text: "Where you see the answers" },
      { t: "p", text: "Answers appear in the “Guests” tab of the event editor." },
      { t: "h2", text: "The RSVP cutoff date" },
      { t: "p", text: "In the same “Guests” tab you can set the “RSVP Cutoff Date”. After this date the RSVP form is hidden from the page. If the gift list is enabled and visible for the event, guests can still reach the gifts from the page." },
      { t: "p", text: "You can change or clear the date at any time from the same place. Without a cutoff date, the form stays available." },
    ],
  },
};
